/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'home': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M967.342 540.654h-67.826v416.978a61.915 61.915 0 01-62.04 61.776H620.378V721.343a41.53 41.53 0 00-41.36-41.701H444.623a41.515 41.515 0 00-41.36 41.7v298.066H186.149a61.9 61.9 0 01-62.024-61.776V540.654H57.787c-42.29 0-73.752-26.234-49.023-52.142a712020 712020 0 01453.87-471.307c22.48-23.27 76.048-22.883 98.543 0 25.07 25.505 426.985 442.188 454.894 472.362 20.478 22.107-2.141 51.087-48.729 51.087z"/>'
  }
})
